<template>
  <v-app id="inspire" :style="[cssProps, pageTitleSizeProps, fontStyle]">
      <v-row class="ma-0 flex-none pa-0  d-flex justify-center align-center z-2" v-if="menus"
      style="background-color: #fff;">
        <v-col cols="12" md="10" xl="8"
          class="d-flex justify-center justify-sm-end align-center pa-1 pr-md-5">

          <!-- <a href="#C" id="gotocenter" title="移動到主要內容" color="block" class="sr-only-focusable rounded-pill" tabindex="0">
            跳到主要內容
          </a> -->
          
          <!-- sr-only sr-only-focusable  -->
          <v-spacer></v-spacer>

          <a href="#U" title="上方主選單區塊" id="AU" accesskey="U" name="U" class="guide" >:::</a>
          <a class="v-btn v-btn--text theme--light v-size--default a-text" :title="`${t('網站導覽')}`"
           href="/guide">
            <span class="v-btn__content">
              {{ t('網站導覽') }}
            </span>
          </a>

          <!-- <a class="v-btn v-btn--text theme--light v-size--default a-text" :title="`${t('網站導覽')}`"
           href="/guide">
            <span class="v-btn__content">
              {{ t('網站導覽') }}
            </span>
          </a> -->
      
          <samp class="pa-0">｜</samp>
          
          <v-menu transition="slide-y-transition"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" aria-expanded="false" aria-haspopup="true"
                :title="`${t('語言選單')}`"  translate="no" class="a-text"
                >
                {{ $store.state.lang == 'zh-TW' ? '繁體中文':
                  $store.state.lang == 'en' ? 'English':
                  $store.state.lang == 'zh-CN' ? '简体':
                  $store.state.lang == 'ko' ? '한국어':
                  $store.state.lang == 'ja' ? '日本語':
                  $store.state.lang == 'vi' ? 'Việt Nam':
                  $store.state.lang == 'id' ? 'Bahasa Indonesia':'' }}
              </v-btn>
            </template>
            <v-list v-if="languageList">
              <v-list-item v-for="(item, index) in languageList" :key="index"
              @click="changeLanguage(item.value)">
                <a translate="no" :title="`${t(item.name)}${t('翻譯按鈕')}`"
                 class="v-list-item__title font-B">
                 <!-- :alt="`${翻譯按鈕}`" -->
                 {{ t(item.name) }}
                </a>
              </v-list-item>
            </v-list>
          </v-menu>
      
          <!-- <v-btn elevation="0" fab small>
            <i class="icon32 fa-brands fa-twitter"></i>
          </v-btn> -->
          <!-- icon32 btn-icon v-btn v-btn--icon v-btn--round v-btn--router theme--light v-size--default -->
          <!-- icon32 btn-icon v-btn v-btn--icon v-btn--round v-btn--router theme--light v-size--default -->
          <samp class="pa-0">｜</samp>
          <p class="pa-0 ma-0">
            <!-- <a :href="facebook" target="_blank"
              :aria-label="`${t('在新視窗')}${t('打開')}${t('大葉大學半導體學士學位學程')}的Facebook頁面`"
              class="icon32 btn-icon v-btn v-btn--icon v-btn--round v-btn--router theme--light v-size--default">
              <i class="fa-brands fa-facebook"></i>
            </a> -->
            <a v-if="data && data[2]"
              :href="`mailto:${data[2].email}`" target="_blank"
              :aria-label="`${t('在新視窗')}${t('使用')}電子郵件發送信件至${t('大葉大學半導體學士學位學程')}`"
              class="icon32 btn-icon v-btn v-btn--icon v-btn--round v-btn--router theme--light v-size--default">
              <i class="fa-solid fa-envelope"></i>
            </a>
          </p>
        </v-col>
      </v-row>

      <!-- Nav Bar 導覽列 -->
      <v-row class="pa-0 ma-0 d-flex justify-center align-center nav" v-if="menus">

        <v-col cols="12" md="10" xl="8" class="py-0 px-3 px-md-0 ma-0 d-flex justify-center align-center" style="height: 55px;">
          <!-- <div class="d-flex align-center"> -->
            <h1 class="d-flex">
              <a href="/" title="大葉大學半導體學士學位學程：回首頁" class="hide-text-re d-flex">
                  <v-img :src="`/tools/${data[1].logo}`" alt="" class="pa-0 ma-0" contain max-height="50px" max-width="140px"></v-img>
                  <span class="pa-0 ma-0" style="color:#fff;" :class="data && data[1]  && data[1].logo? 'hide-text-ab':''">大葉大學半導體學士學位學程</span>
              </a>
            </h1>
            <!-- <router-link  to="/" :title="`回首頁`">
              <template v-if="data && data[1]  && data[1].logo">
                <img  style="max-width: 140px;" :src="`/tools/img/${data[1].logo}`" :alt="`回首頁`">
              </template>
              <template v-else>
                <div class="font-h5 font-B color-white">{{ t('回首頁') }}</div>
              </template>
            </router-link> -->
          <!-- </div> -->
          
          <v-spacer></v-spacer>
          <!-- 手機板 選單 -->
          <v-btn icon aria-expanded="false" aria-haspopup="true" role="menu"  
            v-if="isMobile" type="button" dark
            :aria-label="hidden ?  `${t('關閉選單')}`:`${t('打開選單')}`"
            class="icon32" @click="hidden = !hidden">
            <i class="font-h5" :class="hidden ? 'fa-solid fa-xmark':'fa-solid fa-bars'"></i>
          </v-btn>

          <!-- 網頁版 選單 -->
          <ul v-if="menus" aria-label="上方主選單"
            class="menu justify-center align-center" 
            :class="isMobile? 'display-none':'d-flex'">

            <li v-for="(menu, menuID) in menus.menu" :key="menuID"
            class="d-flex  align-center color-nav-li"
            :class="[menu.children? 'justify-start':'justify-center',
            $store.state.lang == 'zh-CN' || $store.state.lang =='zh-TW' ?'px-5 py-2':'px-4 py-0']">
              
              <a v-if="!menu.children" :href="menu.link" :title="`前往${t(menu.name)}`" 
              class="d-flex justify-center align-center font-20 font-B"
              v-html="t(menu.name)">
              </a>
             
              <p aria-expanded="false" :aria-label="`${t(menu.name)}的選單群組`" tabindex="0"
               v-else :title="`${t(menu.name)}的選單群組`" 
               class="d-flex justify-center align-center font-20 font-B mb-0"
               v-html="t(menu.name)">
              </p>
              <div class="nav-li-div">
                <ul v-if="menu.children" class="nav-li-po px-0 py-4"
                :class="[$store.state.lang == 'zh-CN' || $store.state.lang =='zh-TW' ?'ml-minus-9':'ml-minus-8']">
                  <li v-for="children in menu.children" :key="children.name"
                  class="color-nav-li2 py-2"> 

                    <a  v-if="children.fileName" tabindex="0"
                      :title="`${t(children.name)}`" 
                      class="font-20 w-100"
                      :class="[$store.state.lang == 'zh-CN' || $store.state.lang =='zh-TW' ?'px-5 py-2':'px-4 py-0']"
                      :href="`${children.link}?tag=${children.name}`"
                      v-html="t(children.name)">
                    </a>

                    <a  v-else
                      :title="`${t(children.name)}`" tabindex="0"
                      class="font-20 w-100"
                      :class="[$store.state.lang == 'zh-CN' || $store.state.lang =='zh-TW' ?'px-5 py-2':'px-4 py-0']"
                      :href="`${children.link}`"
                      v-html="t(children.name)">
                    </a>

                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </v-col>
        
        <!-- 手機板 -->
        <v-col cols="12" class="center pa-0" v-if="isMobile" v-show="hidden">
          <v-expansion-panels accordion v-if="menus">
            <v-expansion-panel  class="appNav w-100"
            v-for="(menu, menuID) in menus.menu" :key="menuID">
            
              <a class="v-expansion-panel-header pa-6 py-4" v-if="!menu.children"
                :href="menu.link" :title="`前往${t(menu.name)}`"
                v-html="t(menu.name)">
              </a>
          
              <v-expansion-panel-header v-else
               class="d-flex justify-start color-white" aria-expanded="false"
              :title="`${t(menu.name)}的選單`" aria-haspopup="true">

                <p class="pa-0 ma-0 text-start" v-html="t(menu.name)"></p>
              </v-expansion-panel-header>

              <v-expansion-panel-content v-if="menu.children" 
              class="pa-0 ma-0">
                <v-list-item  v-for="(children, childrenID) in menu.children" :key="childrenID"
                class="pa-0 ma-0 btn-menu-app w-100">
                    <a v-if="children.fileName"
                      :title="`前往${t(children.name)}`" 
                    
                      @click="$router.push({
                        path: children.link,
                        query: {
                          tag: children.name,
                        },
                        })"
                      :href="`${children.link}?tag=${children.name}`"
                      
                      v-html="t(children.name) + ' '">
                    </a>
                    <a v-else
                      class="d-flex"
                      :title="`前往${t(children.name)}`" 

                      :href="children.link"
                      
                      v-html="t(children.name) + ' '">
                    </a>
                </v-list-item>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>


      </v-row>

    <!-- top -->
    <v-btn fab dark v-if="menus"
      :color="$store.state.colorPrimary"
      class="pa-0 d-flex justify-center align-center btn-top"
      style="position: fixed; bottom: 16px; right: 16px; z-index: 99"
      @click="scrollToTop"
      tabindex="0"
      aria-label="回到頂部"
    >
      <label for="scrollToTop" class="d-flex justify-center align-center">  
        <i class="font-h5 fa-solid fa-arrow-up d-flex justify-center align-center"></i>
      </label>
    </v-btn>


    <!-- </nav> -->
    <v-main>
      <div class="guide-ac">
        <a href="#C" title="主要內容區塊" id="AC" accesskey="C" name="C" class="guide" >:::</a>
      </div>
      <router-view/>
    </v-main>

    <v-row class="pa-0 ma-0" v-if="data && menus">
      <v-col cols="12" class="pa-0 ma-0 z-4">
        <Footer :data="data" />
      </v-col>
    </v-row>

  </v-app>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Footer from "./components/footer";
import "@/assets/css/style.css"; // You can also use <link> for styles
import axios from "axios";

export default {
  name: "ScrollTopBtn",

  components: {
    Footer
  },
  data: () => ({
    drawer: null,
    hidden: false, //菜單
    data: [], 

    menus:[],
    languageName: '',
    languageList: [
      { name: "繁體中文", value: "zh-TW" },
      { name: "English", value: "en" },
      { name: "简体中文", value: "zh-CN" },
      { name: "한국어", value: "ko" },
      { name: "日本語", value: "ja" },
      { name: "Việt Nam", value: "vi" },
      { name: "Bahasa Indonesia", value: "id" }
    ],
    languageValue: '',
    mobileDrawer: false,
  }),
  created() {
    this.getLanguageLocalStroage();
    $("#googleTranslateTrigger").change(() => this.googleTranslateInital());
  },
  mounted() {

    //取得菜單
    this.getMenusData();
    this.$store.commit("setPageName", "首頁");

    $.getScript("//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit");

    window.addEventListener("scroll", this.scrolling);

  },
  methods: {

   //回頂部
   scrollToTop() {
      // Scroll to the top of the page
      window.scrollTo({
        top: 0,
        behavior: "smooth" // This creates a smooth scrolling effect
      });
    },

    //取得其他資料
    getMenusData() {
      axios
        .get("/tools/json/menu.json")
        .then((response) => {
          this.data = response.data;
          this.menus = response.data[0];
      })
    },

    onClickDown(){
      const event = new KeyboardEvent('keydown', {
        key: 'ArrowDown',
        code: 'ArrowDown',
        keyCode: 40,
        which: 40,
        bubbles: true,
        cancelable: true,
      });

      // 觸發向下箭頭鍵的模擬事件
      window.dispatchEvent(event);
    },

    // Google翻譯資料
    //取得local storage 內的語言
    getLanguageLocalStroage: function() {

      const self = this;
      var language = localStorage.getItem("language");
      
      if (language == null) language = "zh-TW";
      
      this.$store.state.lang = language;
      localStorage.setItem("language", language);
      this.radioLanguageChange = this.$store.state.lang;

    },
    //更換語言
    changeLanguage: function(value) {
      this.$store.state.lang = value;
      this.setCookie(this.$store.state.lang);
      // console.log(self.$store.state.lang);
    },
    //set Cookie and reload page
    setCookie: function(Value) {
      switch (Value) {
        case "en":
          document.cookie = "googtrans=/zh-TW/" + Value + ";";
          localStorage.setItem("language", "en");
          document.documentElement.setAttribute('lang', 'en');
          break;

        case "zh-CN":
          document.cookie = "googtrans=/zh-TW/" + Value + ";";
          localStorage.setItem("language", "zh-CN");
          document.documentElement.setAttribute('lang', 'zh-Hans');
          break;

        case "zh-TW":
          document.cookie = "googtrans=/zh-TW/" + Value + ";";
          localStorage.setItem("language", "zh-TW");
          document.documentElement.setAttribute('lang', 'zh-Hant');
          break;

        case "ko":
          document.cookie = "googtrans=/ko/" + Value + ";";
          localStorage.setItem("language", "ko");
          document.documentElement.setAttribute('lang', 'ko');
          break;

        case "ja":
          document.cookie = "googtrans=/ja/" + Value + ";";
          localStorage.setItem("language", "ja");
          document.documentElement.setAttribute('lang', 'ko');
          break;

        case "vi":
          document.cookie = "googtrans=/vi/" + Value + ";";
          localStorage.setItem("language", "vi");
          document.documentElement.setAttribute('lang', 'vi');
          break;

        case "id":
          document.cookie = "googtrans=/id/" + Value + ";";
          localStorage.setItem("language", "id");
          document.documentElement.setAttribute('lang', 'id');
          break;
      }
      // console.log(Value);
      location.reload();
    },
    //google translate inital
    googleTranslateInital: async function() {
      // console.log('googleTranslateInital 方法被触发了！');
      //檢查
      const self = this;
      var url_list = [];
      var zh_CN = {}; //簡體中文特殊字彙
      var local_en = {}; //local_英文特殊字彙
      var local_ko = {}; //local_韓文特殊字彙
      var local_ja = {}; //local_日語特殊字彙
      var local_vi = {}; //local_越南特殊字彙
      var local_id = {}; //local_印尼特殊字彙
      var global_en = {}; //global英文特殊字彙
      var merge_en = {}; //整合後英文特殊字彙
      
      // console.log('self.$store.state.isDemo',self.$store.state.isDemo);

      //make url list
      if (self.$store.state.isDemo) {
        switch (self.$store.state.lang.trim()) {
          case "en":
            url_list.push("tools/json/global-en.json");
            url_list.push("tools/json/local-en.json");
            break;
          case "zh-CN":
            url_list.push("tools/json/local-cn.json");
            break;
          case "ko":
            url_list.push("tools/json/local-ko.json");
            break;
          case "ja":
            url_list.push("tools/json/local-ja.json");
            break;
          case "vi":
            url_list.push("tools/json/local-vi.json");
            break;
          case "id":
            url_list.push("tools/json/local-id.json");
            break;
        }
      } else {
        switch (self.$store.state.lang) {
          case "en": //siteSetting/
            url_list.push("tools/json/global-en.json");
            url_list.push("tools/json/local-en.json");
            break;
          case "zh-CN":
            url_list.push("tools/json/local-cn.json");
            break;
          case "ko":
            url_list.push("tools/json/local-ko.json");
            break;
          case "ja":
            url_list.push("tools/json/local-ja.json");
            break;
          case "vi":
            url_list.push("tools/json/local-vi.json");
            break;
          case "id":
            url_list.push("tools/json/local-id.json");
            break;
        }
      }
      //get language and process language data
      // console.log('URL List:', url_list);
      // result.forEach((element, index) => {
      //   console.log(`Response for URL ${index + 1}:`, element.data);
      // });
      // console.log('Merged Data:', merge_en);

      await Promise.all(
        url_list.map(url => axios.get(url + "?" + Math.random()))
      ).then(result => {
        // console.log('result',result)
        // console.log('result[0].config.url',result[0].config.url)

        //make data to tmpObj
        result.forEach(element => {
          var axios_url = element.config.url;
          var tmpObj = {};
          element.data.forEach(word => {
            var key = Object.keys(word)[0];
            var value = word[key];
            tmpObj[key] = value;
          });
         
          //assign value to lanuage variable
          if (axios_url.indexOf("global-en") != -1)
            global_en = Object.assign(tmpObj);
          else if (axios_url.indexOf("local-en") != -1)
            local_en = Object.assign(tmpObj);
          else if (axios_url.indexOf("local-cn") != -1)
            zh_CN = Object.assign(tmpObj);
          else if (axios_url.indexOf("local-ko") != -1)
            local_ko = Object.assign(tmpObj);
          else if (axios_url.indexOf("local-ja") != -1)
            local_ja = Object.assign(tmpObj);
          else if (axios_url.indexOf("local-vi") != -1)
            local_vi = Object.assign(tmpObj);
          else if (axios_url.indexOf("local-id") != -1)
            local_id = Object.assign(tmpObj);
        });
        // console.log('local_ko', local_ko)

        //merge global obj and local obj
        if (self.$store.state.lang == "en")
          merge_en = { ...global_en, ...local_en };
        //assign value to Locales
        if (self.$store.state.lang == "en") {
          this.$translate.setLocales({
            en: merge_en
          });
          this.$translate.setLang("en");
        } else if (self.$store.state.lang == "zh-CN") {
          this.$translate.setLocales({
            zh_CN: zh_CN
          });
          this.$translate.setLang("zh_CN");
        } else if (self.$store.state.lang == "ko") {
          this.$translate.setLocales({
            local_ko: local_ko
          });
          this.$translate.setLang("local_ko");
        } else if (self.$store.state.lang == "ja") {
          this.$translate.setLocales({
            local_ja: local_ja
          });
          this.$translate.setLang("local_ja");
        } else if (self.$store.state.lang == "vi") {
          this.$translate.setLocales({
            local_vi: local_vi
          });
          this.$translate.setLang("local_vi");
        } else if (self.$store.state.lang == "id") {
          this.$translate.setLocales({
            local_id: local_id
          });
          this.$translate.setLang("local_id");
        } 
      });
      // console.log('this.$translate', this.$translate)

      new google.translate.TranslateElement(
        { pageLanguage: "zh-TW" },
        "google_translate_element"
      );
      $("#goog-gt-votingInputSrcLang").attr("title", "google翻譯");
      $("#goog-gt-votingInputTrgLang").attr("title", "google翻譯");
      $("#goog-gt-votingInputSrcText").attr("title", "google翻譯");
      $("#goog-gt-votingInputTrgText").attr("title", "google翻譯");
      $("#goog-gt-votingInputVote").attr("title", "google翻譯");
      $(document.getElementsByName("votingFrame")).attr("title", "google翻譯");
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown; // 当屏幕宽度小于 "md" 断点时返回 true
    },
    isWindow_lg() {
      return this.$vuetify.breakpoint.lgAndDown; // 當屏幕寬度小於 "lg" 斷點時返回 true
    },
    fontStyle(){
      if(this.$vuetify.breakpoint.smAndDown){
        return  {fontSize: '0.875em',} // 約14px=1em
      }else{
        if (this.$store.state.lang === "en" ||
            this.$store.state.lang === "ko" ||
            this.$store.state.lang === "ja" ||
            this.$store.state.lang === "vi" ||
            this.$store.state.lang === "id") {
          return  {fontSize: '0.95em',} // 約18px=1em
          // return  ;
        }else{
          return  {fontSize: '1.125em',} // 約18px=1em
        }
      }
    },
    // store > index.js
    ...mapState([
      "deptName",
      "facebook",
      "deptSName",
      "colorTextBlack",
      "colorTextWhite",
      "colorPrimary",
      "colorPrimaryL",
      "colorPrimaryD",
      "colorSecond",
      "colorThird",
      "colorAlt",
    ]),
    //取得顏色
    cssProps() {
      return {
        "--get-color": this.colorPrimary,
        "--get-color-light": this.colorPrimaryL,
        "--get-color-black": this.colorTextBlack,
        "--get-color-white": this.colorTextWhite,
        "--get-color-primary": this.colorPrimary,
        "--get-color-primary-l": this.colorPrimaryL,
        "--get-color-primary-d": this.colorPrimaryD,
        "--get-color-second": this.colorSecond,
        "--get-color-third": this.colorThird,
        "--get-color-alt": this.colorAlt,
      };
    },
    pageTitleSizeProps() {
      const self = this;
      return {
        "--get-size":
          this.lang == "en"
            ? self.$store.state.mobileState
              ? "2em"
              : "4em"
            : self.$store.state.mobileState
            ? "3em"
            : "4em"
      };
    },
  },
  locales: {
  },
  watch: {

  },

};
</script>

<style lang="scss">
/* 字集開始 */
html {
  margin-bottom: 1.8em; //段落
  letter-spacing: 0.12em; //字元間距
  word-spacing: 0.16em; //字間距
  line-height: 1.5em; //行高度 /* 行高至少為字體大小的1.5倍 */
}
//google翻譯 後整個頁面往上
body{
  // font-family: "Lexend", "GenSenRounded" !important; /* 使用Lexend字体，如果不可用则回退到sans-serif */
  top: 0px !important;
}
a{
  text-decoration: none;
  color: initial;
}
.v-application a{
  color: initial ;
}

//文字校正語言
.v-application{
  font-family: "Lexend", "GenSenRounded" !important; /* 使用Lexend字体，如果不可用则回退到sans-serif */
  // height: 55px !important;
}
h1{
  font-size: 2.027em;
}
h2{
  font-size: 1.802em;
}
h3{
  font-size: 1.602em;
}
h4{
  font-size: 1.424em;
}
h5{
  font-size: 1.266em;
}
h6{
  font-size: 1.125em;
}
p{
  font-size: 1em;
}

.font-p{
  font-size: 1em !important; 
}
.font-20{
  font-size: 1.16em; 
}
.font-14{
  font-size: 0.7em; 
}
.font-h1{
  font-size: 2.027em;
}
.font-h2{
  font-size: 1.802em;
}
.font-h3{
  font-size: 1.602em;
}
.font-h4{
  font-size: 1.424em;
}
.font-h5{
  font-size: 1.266em;
}
.font-h6{
  font-size: 0.85em !important; 
}
.font-B{
  font-weight: bold;
}

/* 字集結束 */
// focusable
.sr-only-focusable {
  padding: 0.1em 0.8em;
  background-color: var(--primary);
  color: var(--bg-white) !important;
  border: 2px solid #000;
  -webkit-transition: top 1s ease-out;
  transition: top 1s ease-out;
}

/*  */
:root{
  --primary: #1950A0; // 主題顏色 - 正常
  --primaryDark: #050F28; // 主題顏色 - 深
  --primaryLight: #A5A0B4; // 主題顏色 - 淺

  --second: #fdcd00; // 輔助顏色01 - 正常 黃色
  --secondDark: #C79F00; // 輔助顏色01 - 深
  --secondLight: #ffEB99; // 輔助顏色01 - 淺

  --third: #E5E5E5; // 輔助顏色02 - 正常 灰色
  --thirdDark: #74655F; // 輔助顏色02 - 深灰
  --thirdLight: #989898; // 輔助顏色02 - 淺灰

  --fourth: #FF5252; // 輔助顏色03 - 正常
  --fourthDark: #B21212; // 輔助顏色03 - 深
  --fourthLight: #FF8A80; // 輔助顏色03 - 淺
  --te-black: #4f4f4f; // 黑色
  --te-white: #FFFFFF; // 白色
  --bg-white: #FFFFFF; // 白色
  --alt: #959595; // 註腳顏色
  --footer: #777; // 註腳顏色
  --error: #e07db2; // #95190C錯誤提示顏色
}
// 關閉google翻譯
.skiptranslate {
  display: none !important;
  iframe {
    display: none;
    height: 0px;
  }
}
// app導覽列
.appNav{
  background-color: var(--primary) !important;
  .v-expansion-panel-header{
    color: var(--te-white);
  }
  a{
    color: var(--te-white) !important;
  }
  .v-icon{
    color: var(--te-white) !important;
  }
}
.appNoIcon{
  .v-expansion-panel-header__icon{
   display: none !important; 
  }
}

// 導覽列
.flex-none{
  flex: none !important;
}

.icon20{
  i{
    font-size: 1.1111em;
    color: var(--alt);
  }
}
.icon24{
  i{
    font-size: 1.3333em;
  }
}

.icon20:hover{
  i{
    color: var(--third) ;
  }
}
.icon20:focus-within{
  i{
    color: var(--third) !important;
  }
}
.icon16{
  width: 1em;
  height: 1em;
  i{
    font-size: 0.8889em;
  }
}

.color-title{
  color: var(--primaryDark);
}
.color-bg-title{
  background-color: var(--primaryDark) ;
  color: var(--te-white);
}
.color-subtitle{
  color: var(--primary);
}

.nav{
 background-color: var(--primary);
 height: 55px !important;
 width: 100%;
 flex: none !important;
 z-index: 7;
 top:0px;
 position: sticky;
 margin: 0px;
}

.menu{
 height: 55px;
 list-style-type: none;
 position: relative;
 li{
  height: 100%;
  // line-height: calc(52px - 1em);
  a{
    text-decoration: none;
    color: var(--te-white) ;
  }
  .nav-li-div{
    position: absolute;
    top: 55px;
    visibility: hidden;
    // display: none;
    ul{
      background-color: var(--te-white);
      list-style-type: none;
      list-style-position: inside ;
      li{
        list-style-type: none;
        list-style-position: inside ;
        a{
          text-decoration: none;
          color: var(--te-black) ;
        }
      }
     }
  }
 }
}

.ml-minus-8{
  margin-left: -15px;
}

.ml-minus-9{
  margin-left: -19px;
}

.btn-a{
  border-radius: 50px;
  padding: 4px 8px;
  color: var(--te-black) !important;
  text-decoration: none;
}
// 測定按鈕 的文字大小
.v-btn.v-size--default, .v-btn.v-size--large{
  font-size: 1em !important;
}
.btn-a:hover{
  color: var(--te-white) !important;
  background-color: var(--thirdDark);
}
.btn-top{
  background-color: var(--primary)!important;
  transition: fill cubic-bezier(1, 0, 0, 1) linear;
}
.btn-top:hover{
  background-color: var(--thirdDark) !important;
}

.color-nav-li{
  color: var(--te-white);
}
.color-nav-li:hover{
  background-color: var(--primaryDark);
  .nav-li-div{
    visibility: visible;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 
                0 4px 8px rgba(0, 0, 0, 0.12);
  }
}
.color-nav-li:focus-within{
  background-color: var(--primaryDark);
  .nav-li-div{
    visibility: visible;
    // display: block;
  }
}
.display-none{
  display: none !important;
}
.color-nav-li2:hover {
  background-color: var(--primary);
  a{
    color: var(--te-white) !important;
    // font-weight: bold;
  }
}
.color-nav-li2:focus-within {
  background-color: var(--primary);
  a{
    color: var(--te-white) !important;
    // font-weight: bold;
  }
}


.color-primary{
  color: var(--primary);
}
.color-bg-primary{
  background-color: var(--primary);
}
.color-black{
  color: var(--te-black);
}
.color-white{
  color: var(--te-white);
}
.color-alt{
  color: var(--alt);
}

.languageList{
  width: 150px;
  z-index: 15;
}

.icon-nav:active menu{
  display: block;
  // color: var(--te-white) !important;
}

.my-overflow-hidden{
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

// 顯示文字排數
.textline-1{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  // -webkit-line-clamp: 1; // 设置显示的行数
}

//其他設定
.w-100{
  width: 100%;
}
.w-fit{ //自適應寬度
  width: fit-content;
}
.h-100{
  height: 100%;
}
.h-fit{
  height:fit-content;
}
.po-r{
  position: relative;
}
.z-1{
  z-index: 1;
}
.z-2{
  z-index: 2;
}
.z-3{
  z-index: 3;
}
.z-4{
  z-index: 4;
}

// 螢幕高度
.h-8vh{
  height: 8vh;
}
.h-10vh{
  height: 10vh;
}
.h-15vh{
  height: 15vh;
}
.h-20vh{
  height: 20vh;
}

//無障礙中央定位
.guide-ac{
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}

//按鈕
.color-btn{
  height: 40px;
  width: fit-content;
  padding: 4px 16px 4px 24px;
  background: var(--primaryDark);
  color: var(--te-white) !important;
  font-size: large; 
  font-weight: bold !important;
    line-height: normal;
    transition: inherit;
    align-items: center;
    display: inline-flex;
    flex: 0 0 auto;
    letter-spacing: 0.0892857143em;
    justify-content: center;
    outline: 0;
    position: relative;
    text-decoration: none;
    text-indent: 0.0892857143em;
    text-transform: uppercase;
    transition-duration: .28s;
    transition-property: box-shadow,transform,opacity;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap; 
  .theme--light.v-icon{
    color: inherit !important;
  }
}
.color-btn:hover{
  transition: opacity .2s cubic-bezier(.4,0,.6,1);
  background: var(--thirdDark);
  color: var(--te-white) !important;
  .theme--light.v-icon{
    color: inherit !important;
  }
}
.color-btn:focus-within{
  transition: opacity .2s cubic-bezier(.4,0,.6,1);
  background: var(--thirdDark);
  color: var(--te-white) !important;
  .theme--light.v-icon{
    color: inherit !important;
  }
}
.btn-icon:hover{
  i{
    color: var(--primary) ;
  }
}
.btn-icon:focus-within{
  i{
    color: var(--primary) ;
  }
}
.a-text:hover{
  color: var(--primary) !important;
  font-weight: bold;
}
.a-text:focus-within{
  color: var(--primary) !important;
  font-weight: bold;
}

//隱藏資料用，但語音會播報
.hide-text-re{
  position: relative;
  .hide-text-ab{
    position: absolute;
    text-indent: -9999px;
    font-size: 0/0 a;
    color: transparent;
  }
}
.btn-menu-app:hover{
  background-color: #ffffff20;
  background-blend-mode: hard-light;
}
.btn-menu-app:focus-within{
  background-color: #ffffff20;
  background-blend-mode: hard-light;
}
.v-expansion-panel-content__wrap{
  padding: 0px!important;
  a{
    width: 100%;
    padding: 0.8rem 2.5rem;
  }
}


</style>